function closestForm(el) {
  if (!el) return null;
  return el.closest ? el.closest('form') : null;
}

function isUpdateForm(form) {
  if (!form) return false;
  var methodEl = form.querySelector('input[name="_method"]');
  return methodEl && (methodEl.value || '').toLowerCase() === 'patch';
}

function setupWorkerUpdateConfirmationModal(root) {
  root = root || document;
  var $ = window.jQuery;
  var modalEl = root.getElementById('worker-update-confirm-modal');
  if (!modalEl || !$ || !$.fn || !$.fn.modal) return;

  var pendingForm = null;

  $(root).on('click', '[data-worker-update-confirm="1"]', function (e) {
    var form = closestForm(this);
    if (!isUpdateForm(form)) return;

    e.preventDefault();
    pendingForm = form;

    $(modalEl).modal('show');
  });

  $(root).on('click', '[data-worker-update-confirm-action]', function () {
    if (!pendingForm) return;

    var mode = ($(this).data('worker-update-confirm-action') || '').toString();
    var modeInput = pendingForm.querySelector('#worker_update_mode');
    if (modeInput) modeInput.value = mode;

    window.onbeforeunload = null;

    $(modalEl).modal('hide');

    if (pendingForm.requestSubmit) {
      pendingForm.requestSubmit();
    } else {
      pendingForm.submit();
    }
  });
}

$(function () {
  setupWorkerUpdateConfirmationModal(document);
});
